import React, { useState } from "react";
import {
  Modal,
  Form,
  Input,
  Upload,
  Button,
  Select,
  message,
  Switch,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Option } = Select;

const CreateProductModal = ({ visible, onClose, onCreate }) => {
  const [form] = Form.useForm();
  const [thumbnailBase64, setThumbnailBase64] = useState(null);

  const handleThumbnailChange = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setThumbnailBase64(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      const currentTime = new Date().toISOString();

      const newProduct = {
        ...values,
        product_thumbnail: thumbnailBase64,
        created_at: currentTime,
        updated_at: currentTime,
      };

      if (!newProduct.product_thumbnail) {
        message.error("썸네일 이미지를 선택해주세요.");
        return;
      }

      await onCreate(newProduct);
      form.resetFields();
      setThumbnailBase64(null);
      message.success("새 상품이 생성되었습니다.");
    } catch (error) {
      message.error("상품 생성에 실패했습니다. 입력 값을 확인해주세요.");
    }
  };

  return (
    <Modal
      title="새 상품 생성"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="brand_name"
          label="브랜드명"
          rules={[{ required: true, message: "브랜드명을 입력해주세요." }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="product_title"
          label="제품명"
          rules={[{ required: true, message: "제품명을 입력해주세요." }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="product_price"
          label="가격"
          rules={[{ required: true, message: "가격을 입력해주세요." }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="product_link"
          label="제품 링크"
          rules={[{ required: true, message: "제품 링크를 입력해주세요." }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="썸네일 업로드">
          <Upload
            beforeUpload={(file) => {
              handleThumbnailChange(file);
              return false; // 실제 업로드 방지
            }}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>썸네일 선택</Button>
          </Upload>
          {thumbnailBase64 && (
            <img
              src={thumbnailBase64}
              alt="업로드된 썸네일"
              width={300}
              style={{ marginTop: "10px" }}
            />
          )}
        </Form.Item>
        <Form.Item
          name="exposure"
          label="상품 노출"
          valuePropName="checked"
          initialValue={true} // 기본값 노출로 설정
        >
          <Switch />
        </Form.Item>
        <Form.Item
          name="is_del"
          label="판매중지 여부"
          valuePropName="checked"
          initialValue={false} // 기본값 판매중으로 설정
        >
          <Switch />
        </Form.Item>
        <div style={{ marginTop: "20px", textAlign: "right" }}>
          <Button
            type="primary"
            onClick={handleCreate}
            style={{ marginRight: 8 }}
          >
            생성
          </Button>
          <Button onClick={onClose}>취소</Button>
        </div>
      </Form>
    </Modal>
  );
};

export default CreateProductModal;
